import { scheduleReminderModalStyles as styles } from "@insite/content-library/Components/ScheduleReminderModal";
import { css } from "styled-components";

styles.titleText = {
    ...styles.titleText,
    variant: "h2",
};

styles.bottomRowGridItem = {
    ...styles.bottomRowGridItem,
    css: css`
        ${styles.bottomRowGridItem?.css}
        gap: 16px;
    `,
};

styles.buttonsContainer = {
    ...styles.buttonsContainer,
    gap: 0,
    offsetCss: css`
        ${styles.buttonsContainer?.offsetCss}
        width: 100%;
        gap: 16px;
        margin: 0;
    `,
};
